import type { PortalStrings } from "./en";

export const ar: PortalStrings = {
  shell: {
    portal: "بوابة العميل",
    nav: {
      home: "الرئيسية",
      case: "قضيتي",
      caseShort: "القضية",
      tasks: "المهام",
      documents: "المستندات",
      profile: "ملفي الشخصي",
      profileShort: "الملف"
    },
    signOut: "تسجيل الخروج",
    language: "اللغة",
    previewing:
      "أنت ترى بوابة {{name}} كما يراها. للعرض فقط: لا يُحفظ أو يُرسل أي شيء هنا.",
    exitPreview: "إغلاق المعاينة",
    privacy: "لا يرى معلوماتك إلا أنت وفريقك القانوني.",
    notClient: "لا توجد بوابة عميل لهذا الحساب",
    notClientBody:
      "اطلب من فريقك القانوني أن يرسل لك دعوة، أو سجّل الدخول بالبريد الإلكتروني الذي وصلته الدعوة.",
    useDifferentEmail: "استخدام بريد إلكتروني آخر",
    cantPreview: "تعذّرت معاينة هذه البوابة",
    loadFailed: "تعذّر تحميل بوابتك. حاول مرة أخرى بعد قليل.",
    retry: "إعادة المحاولة"
  },
  greeting: {
    morning: "صباح الخير يا {{name}}",
    afternoon: "مساء الخير يا {{name}}",
    evening: "مساء الخير يا {{name}}",
    withTasks_one: "هذا هو الشيء الوحيد الذي نحتاجه منك.",
    withTasks_other: "هذا ما نحتاجه منك.",
    stageLine: {
      started: "قضيتك في مرحلة البداية.",
      gathering: "نجمع المعلومات اللازمة لقضيتك.",
      review: "يراجع محاميك قضيتك.",
      filed: "تم تقديم قضيتك إلى USCIS.",
      decision: "قضيتك في مرحلة القرار."
    },
    allCaughtUp: "لا شيء مطلوب منك الآن. سنخبرك عندما نحتاج إلى شيء."
  },
  tasks: {
    title: "ما نحتاجه منك",
    count_one: "مهمة واحدة",
    count_other: "{{count}} مهمة",
    none: "لا شيء الآن",
    noneBody: "عندما يحتاج فريقك القانوني إلى شيء منك، سيظهر هنا.",
    progress: "تمت الإجابة عن {{answered}} من {{total}}",
    minutesLeft_one: "بقيت دقيقة واحدة تقريبًا",
    minutesLeft_other: "بقيت {{count}} دقيقة تقريبًا",
    due: "مطلوب بحلول {{date}}",
    dueToday: "مطلوب اليوم",
    overdue: "كان مطلوبًا بحلول {{date}}",
    changesRequested: "طلب فريقك القانوني تحديث بعض الإجابات",
    start: "ابدأ",
    continue: "تابع",
    update: "تحديث الإجابات",
    opening: "جارٍ الفتح…",
    openFailed:
      "تعذّر فتح هذه المهمة. استخدم الرابط الموجود في بريدك الإلكتروني أو حاول مرة أخرى.",
    previewOnly: "تُفتح المهام للعميل فقط.",
    sign: "راجِع ووقِّع",
    ink: "ابدأ",
    notYet: "ليس بعد",
    signMeta: "نحو {{minutes}} دقائق",
    inkMeta: "اطبع، ووقِّع بالحبر، وأرسل صورة · نحو {{minutes}} دقائق",
    upcoming: "يُفتح عندما يصبح جاهزًا لتوقيعك",
    sendAgain: "طلب منك فريقك القانوني إرساله مرة أخرى"
  },
  case: {
    title: "قضيتك",
    titlePlural: "قضاياك",
    fullTimeline: "الجدول الزمني الكامل",
    now: "ما يحدث الآن",
    onHold: "قضيتك متوقفة مؤقتًا. سيخبرك فريقك القانوني عندما يُستأنف العمل.",
    approved: "تمت الموافقة",
    decision: "صدر القرار",
    receipts: "إيصالات USCIS",
    noReceipts: "سيظهر رقم الإيصال هنا بمجرد أن ترسله USCIS.",
    checkStatus: "التحقق من الحالة لدى USCIS",
    checking: "جارٍ التحقق…",
    checkedAt: "تم التحقق {{when}}",
    statusFailed: "لا تستجيب USCIS الآن. حاول لاحقًا.",
    details: "تفاصيل القضية",
    caseType: "نوع القضية",
    opened: "تاريخ الفتح",
    priorityDate: "تاريخ الأولوية",
    updates: "التحديثات",
    noUpdates: "ستظهر تحديثات قضيتك هنا.",
    none: "لا توجد قضايا بعد",
    noneBody: "عندما يفتح فريقك القانوني قضيتك، يمكنك متابعة تقدمها هنا.",
    back: "كل القضايا",
    notFound: "لم نعثر على هذه القضية.",
    step: "الخطوة {{n}} من {{total}}",
    startedOn: "بدأت في {{date}}",
    nowChip: "الآن",
    waitingOnYou: "بانتظارك",
    open: "فتح",
    attorney: "المحامي",
    receiptNumber: "رقم الإيصال",
    receiptLater: "يظهر هنا بعد التقديم",
    priorityLater: "يُحدَّد عندما تستلم USCIS الطلب",
    questions: "هل لديك أسئلة عن قضيتك؟",
    emailLead: "راسل {{name}}"
  },
  milestone: {
    rfe: "طلبت USCIS أدلة إضافية (طلب أدلة، RFE). {{lead}} يُعدّ الرد وسيخبرك إن كان يحتاج إلى شيء منك.",
    interview:
      "حدّدت USCIS موعد مقابلة. سيساعدك {{lead}} على الاستعداد ويخبرك بما يجب إحضاره.",
    biometrics:
      "وصلت USCIS إلى مرحلة البصمات: أخذ البصمات والصورة في أحد مكاتب USCIS. أحضر خطاب الموعد وبطاقة هوية تحمل صورتك."
  },
  stageAbout: {
    started: "يفتح فريقك القانوني قضيتك ويحدّد ما يحتاجه منك.",
    gathering:
      "نجمع إجاباتك ومستنداتك: من أنت، وتاريخك، والأدلة التي تحتاجها قضيتك.",
    review:
      "يراجع محاميك كل شيء، ويُعدّ النماذج والخطابات، وقد يطرح عليك بعض الأسئلة الإضافية.",
    filed:
      "نقدّم قضيتك إلى USCIS. سيظهر رقم الإيصال هنا بمجرد أن ترسله USCIS، ويمكنك متابعة الحالة من هذه الصفحة.",
    decision:
      "توافق USCIS على القضية، أو تطلب أدلة إضافية (طلب أدلة)، أو ترفضها. سنشرح لك ما سيحدث بعد ذلك."
  },
  stage: {
    started: "البداية",
    gathering: "جمع المعلومات",
    review: "مراجعة المحامي",
    filed: "مقدَّمة إلى USCIS",
    decision: "القرار"
  },
  explainer: {
    yourTeam: "فريقك القانوني",
    yourTeamLower: "فريقك القانوني",
    started: "{{lead}} يُجهّز قضيتك. أي شيء نحتاجه منك سيظهر في هذه الصفحة.",
    gathering:
      "{{lead}} يجمع إجاباتك ومستنداتك. بعد استلام كل شيء، سيراجع {{leadFirst}} الملف ويبدأ في إعداد طلبك.",
    review:
      "{{lead}} يراجع معلوماتك ويُعدّ طلبك. قد تصلك بعض الأسئلة الإضافية.",
    filed:
      "تم تقديم قضيتك إلى USCIS. عادةً ترسل USCIS إشعار استلام بالبريد أولًا، ثم قد تحدّد موعدًا للبصمات. تختلف مدة المعالجة حسب نوع القضية.",
    decision:
      "أصدرت USCIS قرارًا في قضيتك. سيشرح لك {{lead}} معناه والخطوات التالية."
  },
  updates: {
    opened: "تم فتح قضيتك",
    filed: "تم تقديم قضيتك إلى USCIS",
    approved: "وافقت USCIS على قضيتك",
    decided: "أصدرت USCIS قرارًا في قضيتك",
    reopened: "أُعيد فتح قضيتك",
    receipt: "أُضيف إيصال USCIS رقم {{receipt}}",
    receipt_unnamed: "أُضيف إيصال من USCIS",
    questions_sent: "أرسلنا إليك أسئلة للإجابة عنها",
    answers_received: "استلمنا إجاباتك",
    changes_requested: "طلبنا منك تحديث بعض الإجابات",
    answers_reviewed: "تمت مراجعة إجاباتك"
  },
  comingUp: {
    title: "قادم",
    taskDue: "موعد تسليم: {{title}}",
    allDay: "طوال اليوم"
  },
  team: {
    title: "فريقك القانوني",
    email: "راسل {{name}}"
  },
  reminders: {
    title: "للتذكير",
    expiresIn_one: "تنتهي صلاحية {{subject}} غدًا",
    expiresIn_other: "تنتهي صلاحية {{subject}} خلال {{count}} يوم",
    expiresToday: "تنتهي صلاحية {{subject}} اليوم",
    expired: "تاريخ انتهاء {{subject}} المسجّل لدينا كان {{date}}",
    expiresHint: "أخبر فريقك القانوني قبل التجديد أو التخطيط لأي سفر.",
    expiredHint: "إذا حصلت على مستند أحدث، فارفعه حتى يكون لدى فريقك القانوني.",
    yours: {
      status: "وضعك {{status}}",
      immigration_status_expiration: "وضعك في الهجرة",
      i94_expiration: "نموذج I-94 الخاص بك",
      passport_expiration: "جواز سفرك",
      ead_expiration: "تصريح عملك (EAD)",
      advance_parole_expiration: "تصريح السفر المسبق (advance parole) الخاص بك",
      visa_expiration: "تأشيرتك"
    },
    theirs: {
      immigration_status_expiration: "وضع {{name}} في الهجرة",
      i94_expiration: "نموذج I-94 الخاص بـ{{name}}",
      passport_expiration: "جواز سفر {{name}}",
      ead_expiration: "تصريح عمل {{name}} (EAD)",
      advance_parole_expiration:
        "تصريح السفر المسبق (advance parole) الخاص بـ{{name}}",
      visa_expiration: "تأشيرة {{name}}"
    }
  },
  documents: {
    title: "المستندات",
    subtitle: "ما أرسلته إلينا وما شاركه فريقك القانوني معك.",
    upload: "رفع مستند",
    takePhoto: "التقاط صورة",
    uploading: "جارٍ رفع {{name}}…",
    uploaded: "أُرسل {{name}} إلى فريقك القانوني",
    uploadFailed: "تعذّر رفع {{name}}. حاول مرة أخرى.",
    fromYou: "منك",
    fromTeam: "من فريقك القانوني",
    open: "فتح",
    remove: "حذف",
    removed: "تم حذف {{name}}",
    removeFailed: "تعذّر الحذف. حاول مرة أخرى.",
    none: "لا توجد مستندات بعد",
    noneBody:
      "ارفع المستندات التي يطلبها فريقك القانوني، أو عُد لاحقًا لرؤية ما يشاركه معك.",
    previewOnly: "الرفع معطّل في المعاينة.",
    checking: "جارٍ فحص {{name}}…",
    looksGood: "يبدو {{name}} سليمًا",
    weRead: "هذا ما قرأناه منه:",
    mayBeHard: "قد تصعب قراءة {{name}}",
    replace: "استبداله",
    keep: "الاحتفاظ به"
  },
  sign: {
    from: "من {{name}}",
    inkWhy:
      "تشترط USCIS توقيعًا بخط اليد على النماذج الورقية، لذا لا يمكن توقيع هذه الصفحة على الشاشة.",
    read: "اقرأ المستند",
    readHint: "اقرأ كل الصفحات قبل التوقيع.",
    add: "أضف توقيعك",
    draw: "ارسم",
    type: "اكتب",
    drawHint: "وقِّع هنا بإصبعك أو بالفأرة",
    clear: "مسح",
    fullName: "اسمك الكامل",
    consent:
      "أوافق على توقيع هذا المستند إلكترونيًا، وعلى أن توقيعي الإلكتروني له نفس قيمة توقيعي بخط اليد.",
    signAndSend: "وقِّع وأرسل إلى {{name}}",
    signing: "جارٍ التوقيع…",
    audit:
      "نرسل إليك نسخة موقّعة بالبريد الإلكتروني. يُسجَّل توقيعك والوقت وبصمة المستند حتى يمكن التحقق منه لاحقًا.",
    needSignature: "ارسم توقيعك أو اكتبه أولًا.",
    needConsent: "حدِّد المربع للموافقة على التوقيع الإلكتروني.",
    failed: "تعذّر التوقيع. حاول مرة أخرى.",
    signed: "تم التوقيع",
    signedBody:
      "وقّعت هذا المستند في {{date}}. أرسلنا إليك نسخة بالبريد الإلكتروني.",
    signedNoCopy: "وقّعت هذا المستند في {{date}}.",
    downloadSigned: "تنزيل نسختك الموقّعة",
    print: "اطبع الصفحة",
    download: "تنزيل الصفحة المطلوب توقيعها (PDF)",
    noPrinter: "ليست لديك طابعة؟ اطلب من فريقك القانوني إرسالها إليك بالبريد.",
    inkSign: "وقِّع بالحبر الأسود",
    inkBox: "وقِّع في المربع المعنون “{{box}}” في الصفحة {{page}}.",
    inkBoxPage: "وقِّع في مربع التوقيع في الصفحة {{page}}.",
    photo: "التقط صورة للصفحة الموقّعة",
    photoHint: "ضعها مسطّحة في إضاءة جيدة، وتأكد من ظهور الصفحة كاملة.",
    takePhoto: "التقط صورة",
    chooseFile: "اختر ملفًا",
    retake: "أعد التصوير",
    checking: "جارٍ فحص صورتك…",
    found: "عُثر على التوقيع في المربع",
    notFound: "لم نرَ توقيعًا في المربع",
    readable: "الصفحة كاملة ظاهرة وواضحة",
    notReadable: "جزء من الصفحة يصعب قراءته",
    unchecked: "لم نتمكن من فحص هذه الصورة، لكن يمكنك إرسالها على أي حال.",
    send: "أرسل إلى {{name}}",
    sendAnyway: "أرسلها على أي حال",
    sending: "جارٍ الإرسال…",
    uploadFailed: "لم تُرفع الصورة. حاول مرة أخرى.",
    keepOriginal: "احتفظ بالأصل. قد يطلب منك {{name}} إرساله بالبريد.",
    sent: "أُرسل إلى {{name}}",
    sentBody: "سيراجعه {{name}} ويخبرك إن احتاج إلى أي شيء آخر. احتفظ بالأصل.",
    completed: "تم",
    completedBody: "قبِل {{name}} صفحتك الموقّعة.",
    returned: "طلب منك {{name}} إرساله مرة أخرى:",
    upcoming: "ليس جاهزًا بعد",
    upcomingBody: "سيخبرك {{name}} عندما يصبح جاهزًا لتوقيعك.",
    gone: "لم يعد هذا المستند بحاجة إلى توقيعك.",
    back: "العودة إلى المهام",
    previewOnly: "التوقيع معطّل في المعاينة.",
    viewer: "المستند المطلوب توقيعه",
    changed:
      "تغيّر هذا المستند بعد إرساله. سيرسله إليك فريقك القانوني مرة أخرى."
  },
  profile: {
    subtitle:
      "هذه هي المعلومات التي تُكتب في نماذج الهجرة الخاصة بك. إذا كان هناك خطأ أو تغيير، اقترح تصحيحًا وسيراجعه {{name}}.",
    about: "عنك",
    contact: "كيف نتواصل معك",
    lived: "أين عشت",
    worked: "أين عملت",
    studied: "أين درست",
    noneOnFile: "لا شيء مسجّل بعد",
    notOnFile: "غير مسجّل",
    historyHint: "هل هناك شيء ناقص أو خاطئ؟",
    tellUs: "أخبر {{name}}",
    suggest: "اقتراح تصحيح",
    add: "إضافة",
    waiting: "بانتظار مراجعة {{name}}",
    withdraw: "سحب",
    withdrawn: "تم سحب الاقتراح",
    updated: "تم التحديث",
    kept: "أبقى {{name}} المعلومات المسجّلة كما هي.",
    keptWhy: "أبقى {{name}} المعلومات المسجّلة كما هي: {{reason}}",
    note: "هل هناك ما يجب أن يعرفه {{name}}؟",
    notePlaceholder: "مثلًا: جواز سفري فيه التهجئة الصحيحة.",
    addressPlaceholder: "إذا انتقلت إلى سكن جديد، أخبرنا متى.",
    historyLabel: "ما الناقص أو الخاطئ؟",
    historyPlaceholder:
      "مثلًا: سكنت في 12 Elm St, Austin, TX من يونيو 2019 إلى مايو 2020.",
    yourNotes: "ملاحظاتك المرسلة",
    attach: "إرفاق مستند",
    attachHint: "صورة أو ملف PDF يُظهر المعلومة الصحيحة.",
    attaching: "جارٍ رفع {{name}}…",
    attachFailed: "تعذّر رفع هذا الملف. حاول مرة أخرى.",
    removeAttachment: "إزالة المرفق",
    cancel: "إلغاء",
    send: "إرسال إلى {{name}}",
    sending: "جارٍ الإرسال…",
    sent: "أُرسل إلى {{name}} للمراجعة",
    failed: "تعذّر الإرسال. حاول مرة أخرى.",
    unchanged: "هذه هي المعلومات المسجّلة لدينا بالفعل. غيّر شيئًا أولًا.",
    previewOnly: "الاقتراحات معطّلة في المعاينة.",
    present: "حتى الآن",
    topic: {
      legal_name: "الاسم القانوني",
      other_names: "أسماء أخرى استخدمتها",
      birthday: "تاريخ الميلاد",
      birthplace: "مكان الميلاد",
      citizenships: "الجنسية",
      marital_status: "الحالة الاجتماعية",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      physical_address: "عنوان السكن",
      mailing_address: "العنوان البريدي",
      history: "تاريخك"
    },
    field: {
      first_name: "الاسم الأول",
      middle_name: "الاسم الأوسط",
      last_name: "اسم العائلة",
      other_names: "أسماء أخرى، مفصولة بفواصل",
      birthday: "تاريخ الميلاد",
      city_of_birth: "المدينة",
      state_of_birth: "الولاية أو المقاطعة",
      country_of_birth: "الدولة",
      citizenships: "الدول، مفصولة بفواصل",
      marital_status: "الحالة الاجتماعية",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      street: "الشارع ورقم المبنى",
      city: "المدينة",
      state: "الولاية",
      zip_code: "الرمز البريدي",
      country: "الدولة"
    },
    marital: {
      single: "أعزب، لم يتزوج قط",
      married: "متزوج",
      divorced: "مطلّق",
      widowed: "أرمل",
      separated: "منفصل قانونيًا",
      annulled: "زواج مُبطَل"
    }
  },
  signIn: {
    title: "سجّل الدخول إلى بوابتك",
    sentTitle: "تحقّق من بريدك الإلكتروني",
    email: "البريد الإلكتروني",
    send: "أرسل لي رابط تسجيل الدخول",
    sending: "جارٍ الإرسال…",
    hint: "لا حاجة إلى كلمة مرور. سنرسل إلى هذا البريد رابطًا يسجّل دخولك.",
    sent: "إذا كان لـ {{email}} بوابة عميل، فرابط تسجيل الدخول في طريقه إليك. يعمل مرة واحدة وتنتهي صلاحيته خلال ساعة.",
    sendAnother: "استخدام بريد إلكتروني آخر",
    failed: "تعذّر إرسال الرابط. حاول مرة أخرى بعد دقيقة.",
    staff: "تعمل في مكتب محاماة؟",
    staffLink: "سجّل الدخول من هنا"
  },
  welcome: {
    signingIn: "جارٍ تسجيل الدخول…",
    expired: "انتهت صلاحية هذا الرابط",
    used: "تم استخدام هذا الرابط من قبل",
    invalid: "هذا الرابط غير صالح",
    revoked: "هذا الرابط لم يعد يعمل",
    off: "الوصول إلى البوابة متوقف",
    offBody: "اطلب من فريقك القانوني إعادة تفعيله.",
    getNew: "أدخل بريدك الإلكتروني وسنرسل لك رابط تسجيل دخول جديدًا."
  },
  intake: {
    language: "اللغة",
    showEnglish: "عرض بالإنجليزية",
    showTranslated: "عرض بـ{{language}}",
    translating: "جارٍ ترجمة الأسئلة…",
    translationFailed: "تعذّرت ترجمة الأسئلة الآن، لذا فهي بالإنجليزية.",
    answerHint:
      "أجب بالإنجليزية إن استطعت. وإلا فأجب بلغتك وسيترجم فريقك القانوني.",
    defaultNote:
      "خذ وقتك في ملء هذا الاستبيان. تأكد من أن كل المعلومات تطابق مستنداتك الرسمية.",
    defaultTitle: "استبيان عميل الهجرة",
    start: "ابدأ",
    resume: "تابع",
    fix_one: "صحّح إجابة واحدة ←",
    fix_other: "صحّح {{count}} إجابة ←",
    takes_one: "يستغرق دقيقة واحدة تقريبًا",
    takes_other: "يستغرق {{count}} دقيقة تقريبًا",
    left_one: "بقيت دقيقة واحدة تقريبًا",
    left_other: "بقيت {{count}} دقيقة تقريبًا",
    about_one: "دقيقة واحدة تقريبًا",
    about_other: "{{count}} دقيقة تقريبًا",
    othersSaved_one: " · الإجابة الأخرى محفوظة",
    othersSaved_other: " · الإجابات الأخرى ({{count}}) محفوظة",
    needsChanges_one: "راجع محاميك إجاباتك ويحتاج إلى تعديل واحد.",
    needsChanges_other: "راجع محاميك إجاباتك ويحتاج إلى {{count}} تعديل.",
    attorney: "المحامي",
    yourAttorney: "محاميك",
    yourAttorneyLower: "محاميك",
    yourFirm: "مكتب المحاماة",
    you: "أنت",
    welcomeBack: "مرحبًا بعودتك",
    welcomeBackName: "مرحبًا بعودتك يا {{name}}.",
    resumeBody: "لقد بدأت هذا الاستبيان من قبل. هل تريد المتابعة من حيث توقفت؟",
    continueWhereLeft: "المتابعة من حيث توقفت",
    reviewFromStart: "المراجعة من البداية",
    ok: "موافق",
    skip: "تخطٍّ",
    continue: "متابعة",
    submit: "إرسال",
    sendTo: "إرسال إلى {{name}}",
    yes: "نعم",
    no: "لا",
    previousStep: "الخطوة السابقة",
    nextStep: "الخطوة التالية",
    displaySettings: "إعدادات العرض",
    typeAnswer: "اكتب إجابتك هنا...",
    yourAnswer: "إجابتك",
    typeOrSelect: "اكتب أو اختر خيارًا",
    noMatches: "لا توجد خيارات مطابقة",
    street: "عنوان الشارع",
    city: "المدينة",
    state: "الولاية / المقاطعة",
    statePlaceholder: "الولاية",
    postal: "الرمز البريدي",
    postalPlaceholder: "الرمز البريدي",
    country: "الدولة",
    dragDrop: "اسحب ملفاتك وأفلتها هنا",
    uploadingShort: "جارٍ الرفع...",
    upload: "رفع",
    uploadMore: "رفع المزيد",
    uploadedFiles: "الملفات المرفوعة",
    uploadingDocument: "جارٍ رفع المستند",
    uploaded: "تم الرفع",
    uploadedBody_one: "تم رفع ملفك بنجاح.",
    uploadedBody_other: "تم رفع {{count}} ملف بنجاح.",
    someFailed: "تعذّر رفع بعض الملفات",
    uploadFailed: "فشل الرفع",
    pleaseTryAgain: "يُرجى المحاولة مرة أخرى.",
    saved: "تم الحفظ",
    savedBody: "يمكنك إغلاق هذه الصفحة والعودة لاحقًا باستخدام الرابط نفسه.",
    couldntSave: "تعذّر الحفظ",
    submitted: "تم الإرسال",
    submittedBody: "تم إرسال إجاباتك.",
    couldntSubmit: "تعذّر الإرسال",
    thankYou: "شكرًا لك!",
    thankYouBody:
      "استلم فريقك القانوني إجاباتك وسيراجعها قريبًا. يمكنك إغلاق هذه النافذة الآن.",
    review: "راجع إجاباتك",
    reviewBody:
      "راجع إجاباتك قبل الإرسال. يمكنك تعديل أي شيء تحتاج إلى تغييره.",
    reviewGroupBody: "يمكنك تعديل أي إدخال أو حذفه، أو إضافة إدخال جديد.",
    edit: "تعديل",
    remove: "حذف",
    notAnswered: "بلا إجابة",
    notProvided: "غير مقدَّم",
    noEntries: "لا توجد إدخالات.",
    noEntriesAdded: "لم تُضَف أي إدخالات.",
    noEntriesYet: "لم تُضَف أي إدخالات بعد.",
    noEntriesSubmitted: "لم تُرسَل أي إدخالات.",
    noDetails: "لا توجد تفاصيل بعد.",
    noDocChanges: "لم يُطلب أي تغيير في المستندات.",
    noDocs: "لا توجد مستندات.",
    leaveComment: "اكتب تعليقًا...",
    addComment: "إضافة تعليق",
    addReply: "إضافة رد",
    cancel: "إلغاء",
    youSent: "أرسلت",
    youAnswered: "أجبت:",
    addAnother: "إضافة واحد آخر؟",
    loadFailed: "تعذّر تحميل الاستبيان",
    oops: "عذرًا، حدث خطأ ما.",
    persists: "إذا استمرت المشكلة، تواصل مع مكتب المحاماة.",
    tryAgain: "إعادة المحاولة",
    attention_one: "ملف واحد يحتاج إلى انتباهك",
    attention_other: "{{count}} ملف تحتاج إلى انتباهك",
    attentionBody: "قد يطلب منك محاميك إعادة إرسالها.",
    sendAnyway: "إرسال على أي حال",
    savesAuto: "يُحفظ تقدّمك تلقائيًا",
    prefilledCount_one: "إجابة واحدة معبّأة مسبقًا",
    prefilledCount_other: "{{count}} إجابة معبّأة مسبقًا",
    progressOf: "{{current}} من {{total}}",
    savedAt: "حُفظ {{time}}",
    backToPortal: "العودة إلى بوابتك",
    outline: {
      questions_one: "سؤال واحد",
      questions_other: "{{count}} سؤال",
      filled_one: "واحد معبّأ",
      filled_other: "{{count}} معبّأة",
      minutes_one: "دقيقة واحدة",
      minutes_other: "{{count}} دقيقة",
      done: "مكتمل"
    },
    prefill: {
      ask: "هل هذا صحيح؟",
      yes: "نعم، هذا صحيح",
      change: "تغييره",
      fromDocs: "من مستنداتك",
      onFile: "موجود في ملفك"
    },
    date: {
      day: "اليوم",
      month: "الشهر",
      year: "السنة",
      pickMonth: "اختر شهرًا",
      echo: "كتبت: {{date}}",
      invalid: "هذا التاريخ غير موجود. تحقّق من اليوم والشهر."
    },
    ph: {
      email: "name@example.com",
      phone: "+1 555 123 4567",
      givenName: "كما يظهر في جواز سفرك",
      familyName: "كما يظهر في جواز سفرك",
      middleName: "اتركه فارغًا إن لم يكن لديك",
      otherNames: "أي أسماء أخرى استخدمتها",
      fullName: "الاسم الكامل",
      number: "كما هو مطبوع في المستند",
      city: "المدينة",
      country: "البلد",
      employer: "الشركة أو المؤسسة",
      jobTitle: "مسمّاك الوظيفي",
      school: "المدرسة أو الجامعة",
      website: "https://",
      longText: "اكتب إجابتك هنا…",
      answer: "اكتب إجابتك هنا…"
    },
    group: {
      tellUs: "أخبرنا عن: {{name}}.",
      tellUsAddresses: "أخبرنا عن عناوينك السابقة.",
      tellUsEmployment: "أخبرنا عن تاريخك الوظيفي.",
      tellUsStatuses: "أخبرنا عن تاريخ وضعك في الهجرة.",
      tellUsTrips: "أخبرنا عن دخولك إلى الولايات المتحدة وخروجك منها.",
      tellUsDependents: "أخبرنا عن المعالين.",
      leadIn: "هل لديك ما تضيفه إلى: {{name}}؟",
      leadInAddresses: "هل لديك عناوين سابقة تريد إضافتها؟",
      leadInEmployment: "هل لديك وظائف سابقة تريد إضافتها؟",
      leadInStatuses: "هل لديك أوضاع هجرة سابقة تريد إضافتها؟",
      leadInTrips:
        "هل لديك رحلات دخول أو خروج من الولايات المتحدة تريد إضافتها؟",
      addAnother: "إضافة عنصر آخر إلى: {{name}}؟",
      addAnotherAddress: "إضافة عنوان آخر؟",
      addAnotherEmployer: "إضافة صاحب عمل آخر؟",
      addAnotherStatus: "إضافة وضع آخر؟",
      addAnotherTrip: "إضافة رحلة أخرى؟",
      review: "راجع: {{name}}",
      reviewAddresses: "راجع عناوينك",
      reviewEmployers: "راجع أصحاب العمل",
      reviewStatuses: "راجع أوضاعك",
      reviewTrips: "راجع رحلاتك",
      entries: "إدخالات"
    }
  },
  common: {
    loading: "جارٍ التحميل…",
    today: "اليوم",
    yesterday: "أمس",
    daysAgo_one: "منذ يوم واحد",
    daysAgo_other: "منذ {{count}} يوم"
  }
};

/*
 * Arabic has six plural forms and i18next falls back to English, not to
 * `_other`, when one is missing, so every counted key needs all of them.
 */
export const arPlurals = {
  greeting: {
    withTasks_zero: "هذا ما نحتاجه منك.",
    withTasks_two: "هذان هما الشيئان اللذان نحتاجهما منك.",
    withTasks_few: "هذا ما نحتاجه منك.",
    withTasks_many: "هذا ما نحتاجه منك."
  },
  tasks: {
    count_zero: "لا مهام",
    count_two: "مهمتان",
    count_few: "{{count}} مهام",
    count_many: "{{count}} مهمة",
    minutesLeft_zero: "لم يبقَ وقت تقريبًا",
    minutesLeft_two: "بقيت دقيقتان تقريبًا",
    minutesLeft_few: "بقيت {{count}} دقائق تقريبًا",
    minutesLeft_many: "بقيت {{count}} دقيقة تقريبًا"
  },
  reminders: {
    expiresIn_zero: "تنتهي صلاحية {{subject}} اليوم",
    expiresIn_two: "تنتهي صلاحية {{subject}} خلال يومين",
    expiresIn_few: "تنتهي صلاحية {{subject}} خلال {{count}} أيام",
    expiresIn_many: "تنتهي صلاحية {{subject}} خلال {{count}} يومًا"
  },
  intake: {
    fix_zero: "لا إجابات للتصحيح",
    fix_two: "صحّح إجابتين ←",
    fix_few: "صحّح {{count}} إجابات ←",
    fix_many: "صحّح {{count}} إجابة ←",
    takes_zero: "يستغرق أقل من دقيقة",
    takes_two: "يستغرق دقيقتين تقريبًا",
    takes_few: "يستغرق {{count}} دقائق تقريبًا",
    takes_many: "يستغرق {{count}} دقيقة تقريبًا",
    left_zero: "أقل من دقيقة متبقية",
    left_two: "بقيت دقيقتان تقريبًا",
    left_few: "بقيت {{count}} دقائق تقريبًا",
    left_many: "بقيت {{count}} دقيقة تقريبًا",
    about_zero: "أقل من دقيقة",
    about_two: "دقيقتان تقريبًا",
    about_few: "{{count}} دقائق تقريبًا",
    about_many: "{{count}} دقيقة تقريبًا",
    othersSaved_zero: "",
    othersSaved_two: " · الإجابتان الأخريان محفوظتان",
    othersSaved_few: " · الإجابات الـ{{count}} الأخرى محفوظة",
    othersSaved_many: " · الإجابات الأخرى ({{count}}) محفوظة",
    needsChanges_zero: "راجع محاميك إجاباتك.",
    needsChanges_two: "راجع محاميك إجاباتك ويحتاج إلى تعديلين.",
    needsChanges_few: "راجع محاميك إجاباتك ويحتاج إلى {{count}} تعديلات.",
    needsChanges_many: "راجع محاميك إجاباتك ويحتاج إلى {{count}} تعديلًا.",
    uploadedBody_zero: "لم يُرفع أي ملف.",
    uploadedBody_two: "تم رفع ملفين بنجاح.",
    uploadedBody_few: "تم رفع {{count}} ملفات بنجاح.",
    uploadedBody_many: "تم رفع {{count}} ملفًا بنجاح.",
    attention_zero: "لا ملفات تحتاج إلى انتباهك",
    attention_two: "ملفان يحتاجان إلى انتباهك",
    attention_few: "{{count}} ملفات تحتاج إلى انتباهك",
    attention_many: "{{count}} ملفًا تحتاج إلى انتباهك",
    prefilledCount_zero: "لا إجابات معبّأة مسبقًا",
    prefilledCount_two: "إجابتان معبّأتان مسبقًا",
    prefilledCount_few: "{{count}} إجابات معبّأة مسبقًا",
    prefilledCount_many: "{{count}} إجابة معبّأة مسبقًا",
    outline: {
      questions_zero: "لا أسئلة",
      questions_two: "سؤالان",
      questions_few: "{{count}} أسئلة",
      questions_many: "{{count}} سؤالًا",
      filled_zero: "لا شيء معبّأ",
      filled_two: "اثنان معبّآن",
      filled_few: "{{count}} معبّأة",
      filled_many: "{{count}} معبّأة",
      minutes_zero: "أقل من دقيقة",
      minutes_two: "دقيقتان",
      minutes_few: "{{count}} دقائق",
      minutes_many: "{{count}} دقيقة"
    }
  },
  common: {
    daysAgo_zero: "اليوم",
    daysAgo_two: "منذ يومين",
    daysAgo_few: "منذ {{count}} أيام",
    daysAgo_many: "منذ {{count}} يومًا"
  }
};
